// extracted by mini-css-extract-plugin
module.exports = {"loader-wrapper":"styles_loader-wrapper__DALUa","background":"styles_background__k3Rfd","with-opacity":"styles_with-opacity__71y84","spinner":"styles_spinner__vHLnY"};